import Link from '@components/v2/ui/Link/Link';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface BusinessPolicyViolationDetailsLinkProps {
  onOpenDetails: () => void;
}

const BusinessPolicyViolationDetailsLink = ({
  onOpenDetails,
}: BusinessPolicyViolationDetailsLinkProps) => {
  const { translate } = useTranslation();

  return (
    <Link
      component="button"
      color="inherit"
      underline="always"
      onClick={onOpenDetails}
      sx={{ typography: 'micro2', textAlign: 'left', alignSelf: 'flex-start' }}
    >
      {translate(LangEnum.BUSINESS_POLICY_VIOLATION_CLICK_FOR_DETAILS)}
    </Link>
  );
};

export default BusinessPolicyViolationDetailsLink;
